import React, { useEffect, useMemo, useState } from "react";
import Badge from "components/badge";
import DataTable from "components/data-table";
import { SearchInput, Select } from "components/fields";
import { PageContainer, PageHeader } from "components/page";
import { EmptyState } from "components/states";

const ROLE_OPTIONS = [
  { value: "", label: "All Roles" },
  { value: "Volunteer", label: "Volunteer" },
  { value: "Admin", label: "Admin" },
];

const TIME_OPTIONS = [
  { value: "", label: "All Time" },
  { value: "Today", label: "Today" },
  { value: "This Week", label: "This Week" },
];

const COLUMNS = [
  {
    accessorKey: "name",
    header: "Name",
    cell: ({ getValue }) => <span className="font-medium text-fg">{getValue()}</span>,
  },
  { accessorKey: "campus", header: "Campus" },
  {
    accessorKey: "occupancy",
    header: "Occupancy",
    cell: ({ getValue }) => (
      <Badge tone={getValue() < 85 ? "success" : "danger"}>{getValue()}%</Badge>
    ),
  },
];

const Occupancy = () => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    setData([
      {
        name: "Room name",
        campus: "Campus name",
        occupancy: parseInt(Math.random() * 100),
      },
      {
        name: "Room name",
        campus: "Campus name",
        occupancy: parseInt(Math.random() * 100),
      },
      {
        name: "Room name",
        campus: "Campus name",
        occupancy: parseInt(Math.random() * 100),
      },
    ]);
  }, []);

  const rows = useMemo(() => {
    const query = search.trim().toLowerCase();
    return query ? data.filter((row) => row.name.toLowerCase().includes(query)) : data;
  }, [data, search]);

  return (
    <PageContainer>
      <PageHeader title="Occupancy" />

      <div className="flex flex-wrap items-end gap-2">
        <SearchInput
          value={search}
          onChange={setSearch}
          placeholder="Find by room name"
          ariaLabel="Find by room name"
          className="w-full md:w-80"
        />
        <Select aria-label="Role" defaultValue="" options={ROLE_OPTIONS} className="w-full sm:w-44" />
        <Select
          aria-label="Time range"
          defaultValue=""
          options={TIME_OPTIONS}
          className="w-full sm:w-44"
        />
      </div>

      <DataTable
        aria-label="Room occupancy"
        columns={COLUMNS}
        data={rows}
        pagination
        emptyState={<EmptyState variant="filtered" />}
      />
    </PageContainer>
  );
};

export default Occupancy;
